import { render, staticRenderFns } from "./AssignmentButtons.vue?vue&type=template&id=0b562ef9"
import script from "./AssignmentButtons.vue?vue&type=script&lang=js"
export * from "./AssignmentButtons.vue?vue&type=script&lang=js"
import style0 from "./AssignmentButtons.vue?vue&type=style&index=0&id=0b562ef9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports